<template>
  <section class="section pt-0">
    <promotion-datatable />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import PromotionDatatable from "./member_promotion_datatable/Index.vue";

export default {
  name: "Gym_memberPromotion",
  components: { PromotionDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    // retrieve_settings() {
    //   let v = this;
    //   get_configuration(this)
    //     .then((conf) => {
    //       v.module_settings = conf;
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    // },
    // create() {
    //   console.log("create order");
    // },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {
    // let v = this;
    // v.retrieve_settings();
  },
  created() {},
};
</script>

<style scoped></style>
